export default (props) => {
	const {
		title,
		formId,
		portalId,
		fontColor,
		hideElementInSmallScreen = { value: false },
		redirectionTo = { enable: false },
		isTwoColumnForm,
		matchStyleToIframeForm,
	} = props;

	return {
		title,
		formId,
		portalId,
		fontColor: fontColor.color,
		hideElementInSmallScreen: hideElementInSmallScreen.value,
		redirectionTo,
		isTwoColumnForm,
		matchStyleToIframeForm,
	};
};
